/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { map, get, remove, includes, size, tail, slice, last } from 'lodash'
import { jsx, css } from '@emotion/react'
import MainLayout from './MainLayout'
import CommonTable from './CommonTable'
import { VoiceDetailsModal } from './VoiceDetailsModal'
import { Trans } from 'react-i18next'
import { Duration } from './Duration'
import { customerList } from '../actions/customer'
import { Container, Navbar, Nav, Col, Row } from 'react-bootstrap'
import WrappingBusyMask from './WrappingBusyMask'
import Timestamp from './Timestamp'
import { PhoneNumber } from './PhoneNumber'
import { Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { InlineIcon } from './layout/InlineIcon'
import { InlineIconBar } from './layout/InlineIconBar'
import { cdrTypes } from '../actions/dropdown_options'

class VoiceTraffic extends Component {

    constructor(props) {
        super(props)
        this.state = { showing_voice_item_details: null }
    }

    componentDidMount() {
        const { dispatch, cdrList } = this.props
        dispatch(cdrList.fetchListIfNeeded())
        dispatch(customerList.ensureCustomerLoaded())
        dispatch(cdrTypes.updatePaginationNumItemsPerPage(1000))
        dispatch(cdrTypes.fetchListIfNeeded())
    }

    componentDidUpdate(prev_props) {
        const { dispatch, cdrList } = this.props
        dispatch(cdrList.fetchListIfNeeded())
    }
    
    onShowItemDetails = (item) => {
        const { dispatch, cdrList } = this.props
        dispatch(cdrList.invalidateObject(item.id))
        dispatch(cdrList.ensureObjectLoaded(item.id))
        this.setState({showing_voice_item_details: item})
    }
    
    onHideItemDetails = (item) => {
        this.setState({showing_voice_item_details: null})
    }

    renderOutgoingVoiceQueueItemId(voice_queue_item) {
        return (
            <div key={voice_queue_item.id}>
              {voice_queue_item.short_id}
            </div>
        )
    }

    getVoiceCellValue = (header_key, item, index) => {
        const { customer_id, cdr_types } = this.props
        let display_name = null
        switch( header_key ) {
            case 'start_datetime':
                return (
                    <Timestamp value={item.start_datetime} format="dateshort-time" />
                )
            case 'duration_seconds':
                return (
                    <Duration seconds={item.duration_seconds} />
                )
            case 'source':
                return (
                    <PhoneNumber phone_number={get(item, ["source_number"], "Unknown")} />
                )
            case 'destination':
                return (
                    <PhoneNumber phone_number={get(item, ["destination_number"], "Unknown")} />
                )
            case 'forwarded_to':
                switch(item.cdr_type) {
                    case "voice_message":
                        return (
                            <div css={cell_row_style}>
                              <InlineIcon icon_name="voice_message" />
                              {get(item, ["incoming_voice_message", "voice_message_sent_to_email_address"])}
                            </div>
                        )
                    case "forwarded":
                        return (
                            <div css={cell_row_style}>
                              <InlineIcon icon_name="phone" />
                              <PhoneNumber phone_number={get(item, "final_number")} />
                            </div>
                        )
                    case "immediate_hangup":
                        return (
                            <div css={cell_row_style}>
                              <InlineIcon icon_name="phoneslash" />
                              <Trans>Hung up</Trans>
                            </div>
                        )
                    default:
                        return get(cdr_types, [item.cdr_type, "name"], item.cdr_type)
                }
            // case 'action':
            //     return (
            //         <div css={action_inner_style}>
            //           <InlineIcon icon_name="info" size_variant="h16" variant="blue" onClick={() => this.onShowItemDetails(item)} />
            //         </div>
            //     )
            default:
                return undefined
        }
    }

    renderCustomerNotFullyMigratedMessage() {
        return (
            <div>
              <Trans>While we migrate your account data, yesterday's calls may not show up here yet. Please check back tomorrow.</Trans>
            </div>
        )
    }
    
    render() {
        const { is_ready, is_loading, voice_headers, cdrs, cdrList, migration_from_legacy_in_progress } = this.props
        const { showing_voice_item_details } = this.state
        return (
            <div>
              <WrappingBusyMask is_loading={!is_ready}>
                <CommonTable is_loading={ is_loading }
                             empty_message={`There are no matching calls`}
                             headers={ voice_headers }
                             items={Object.assign([], cdrs)}
                             item_list={cdrList}
                             sub_header_message={migration_from_legacy_in_progress ? this.renderCustomerNotFullyMigratedMessage() : ""}
                             getCellValue={ this.getVoiceCellValue }
                />
              </WrappingBusyMask>
              { showing_voice_item_details &&
                <VoiceDetailsModal cdrList={cdrList}
                                   cdr_id={showing_voice_item_details.id}
                                   onClose={this.onHideItemDetails} />
              } 
            </div>
        )
    }
    
}


function mapStateToProps(state, props) {

    const { cdrList, voice_headers } = props
    const cdrs = cdrList.getVisibleObjects()
    const customer = customerList.getCustomer()
    const migration_from_legacy_in_progress = get(customer, "migration_from_legacy_in_progress", false)
    const cdr_types = cdrTypes.getObjectsById()
    
    return {
        cdrs,
        cdr_types,
        voice_headers: voice_headers || {
            start_datetime: { name: <Trans>Date/Time</Trans>, td_style: start_datetime_cell_style },
            duration_seconds: { name: <Trans>Duration</Trans>, td_style: duration_cell_style },
            source: { name: <Trans>From</Trans>, td_style: from_cell_style },
            destination: { name: <Trans>To</Trans>, td_style: to_cell_style },
            forwarded_to: { name: <Trans>Forwarded to</Trans>, td_style: to_cell_style },
            // action: { name: '', td_style: action_style },
        },
        migration_from_legacy_in_progress,
        is_ready: cdrList.isReady(),
        is_loading: cdrList.isLoading()
    }
}

export default withRouter(connect(mapStateToProps)(VoiceTraffic))

const filename_field_style = css`
`

const start_datetime_cell_style = css`
vertical-align: top;
width: 150px;
`

const from_cell_style = css`
vertical-align: top;
width: 15%;
`

const duration_cell_style = css`
vertical-align: top;
width: 15%;
`

const to_cell_style = css`
vertical-align: top;
width: 15%;
`

const action_style = css`
vertical-align: top;
width: 20px;
`

const action_inner_style = css`
margin-top: 3px;
`

const cell_row_style = css`
display: flex;
align-items: center;
`
